export const siteSettings = {
  name: "Harvest Drift",
  link: "https://harvestdrift.net",
  email: "support@harvestdrift.net",
  appLink: "https://app.harvestdrift.net",
};
